/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import React, { styled } from 'fierry/react.old';


const Line = styled.line`

  stroke: var(--fierry-theme-background);

  stroke-width: 1;
  stroke-linecap: round;
`;


const DashedLine = styled(Line)`
  stroke-dasharray: 1 5;
`;


const getVerticalLineProps = ({ geometry, location }, delta) =>
{
  const hex = geometry.getHex();
  const zone = geometry.getZone(location);

  const width = hex.getExternalWidth();
  const height = hex.getExternalHeight();

  const [ pointA, pointB ] = zone.getClippedLine({ x: delta * width, y: -1/2 * height }, { x: delta * width, y: 1/2 * height });

  return { x1: pointA.x, y1: pointA.y, x2: pointB.x, y2: pointB.y };
}


const getHorizontalLineProps = ({ geometry, location }, delta) =>
{
  const hex = geometry.getHex();
  const zone = geometry.getZone(location);

  const width = hex.getExternalWidth();
  const height = hex.getExternalHeight();

  const [ pointA, pointB ] = zone.getClippedLine({ x: -1/2 * width, y: delta * height }, { x: 1/2 * width, y: delta * height });

  return { x1: pointA.x, y1: pointA.y, x2: pointB.x, y2: pointB.y };
}


const getDecreaseLineProps = ({ geometry, location }, delta) =>
{
  const hex = geometry.getHex();
  const zone = geometry.getZone(location);

  const width = hex.getExternalWidth();
  const height = hex.getExternalHeight();

  const [ pointA, pointB ] = zone.getClippedLine({ x: -1/2 * width, y: (-1/4 + delta) * height }, { x: 1/2 * width, y: (1/4 + delta) * height });

  return { x1: pointA.x, y1: pointA.y, x2: pointB.x, y2: pointB.y };
}


const getIncreaseLineProps = ({ geometry, location }, delta) =>
{
  const hex = geometry.getHex();
  const zone = geometry.getZone(location);

  const width = hex.getExternalWidth();
  const height = hex.getExternalHeight();

  const [ pointA, pointB ] = zone.getClippedLine({ x: -1/2 * width, y: (1/4 + delta) * height }, { x: 1/2 * width, y: (-1/4 + delta) * height });

  return { x1: pointA.x, y1: pointA.y, x2: pointB.x, y2: pointB.y };
}


export const VerticalStripe = (props) =>
(
  <>
    <Line {...getVerticalLineProps(props, -5/60)} />
    <Line {...getVerticalLineProps(props,     0)} />
    <Line {...getVerticalLineProps(props,  5/60)} />
  </>
);


export const HorizontalStripe = (props) =>
(
  <>
    <Line {...getHorizontalLineProps(props, -5/60)} />
    <Line {...getHorizontalLineProps(props,     0)} />
    <Line {...getHorizontalLineProps(props,  5/60)} />
  </>
);


export const DecreaseStripe = (props) =>
(
  <>
    <Line {...getDecreaseLineProps(props, -1/4)} />
    <Line {...getDecreaseLineProps(props,    0)} />
    <Line {...getDecreaseLineProps(props,  1/4)} />
  </>
);


export const IncreaseStripe = (props) =>
(
  <>
    <Line {...getIncreaseLineProps(props, -1/4)} />
    <Line {...getIncreaseLineProps(props,    0)} />
    <Line {...getIncreaseLineProps(props,  1/4)} />
  </>
);


export const IncreaseDashStripe = (props) =>
(
  <>
    <DashedLine {...getIncreaseLineProps(props, -1/4)} />
    <DashedLine {...getIncreaseLineProps(props,    0)} />
    <DashedLine {...getIncreaseLineProps(props,  1/4)} />
  </>
);


export default (props) =>
{
  const { location } = props;

  if (location.getZone().getEnergy().isCurrentOwnerWinner())
  {
    return null;
  }

  return <DecreaseStripe {...props} />;
}
